// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9c172ee0","455":"b80698e2","977":"e2d4c299"}[chunkId] + ".chunk.js";
};